<div
  class="sub-nav-item"
  (click)="navItemSelected(); $event.stopPropagation()"
  [class.sub-active]="viewModel.isNavItemActive$ | async">
  {{ subItem?.name }}
  @if (viewModel.showNavItemAlertIndicator$ | async) {
    <span class="alert-indicator">&nbsp;</span>
  }
</div>
